<template>
  <div class="subcription-selling-points">
    <QList :class="$q.screen.gt.xs ? 'q-ml-xl' : ''">
      <QItem v-for="(sellingPoint, index) in sellingPoints" :key="index">
        <QItemSection avatar>
          <QIcon color="secondary" name="verified" />
        </QItemSection>
        <QItemSection>
          <QItemLabel>{{ sellingPoint }}</QItemLabel>
        </QItemSection>
      </QItem>
    </QList>
    <div v-if="picture" class="subcription-selling-points-img desktop-screens">
      <img style="height:200px;" :src="picture" alt="offer_picture" @error="onImgError" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    sellingPoints: {
      type: Array,
      default: () => [],
    },
    picture: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    onImgError(event) {
      // we hide the full tag in case of picture error
      event.target.style.display = "none";
    },
  },
};
</script>

<style lang="scss">
.subcription-selling-points {
  display: flex;
  justify-content: center;
  min-height: 30vh;

  .subcription-selling-points-img {
    display: flex;
    align-items: center;
  }
}
</style>
